<script lang="ts">
    import type { RewardsGiftCardReward } from "@apps/rewards/entities/entities";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    import T from "@components/T.svelte";

    import RewardsCurrency from "../RewardsCurrency.svelte";

    //Props
    export let reward: RewardsGiftCardReward;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let namespace: TranslationNamespaces;
    export let sanitizer: HTMLSanitizerInterface;
</script>

<RewardsCurrency
    let:amount
    amount={reward.initialValue}
    {currencyFormatter}
    {sanitizer}
>
    <T
        {namespace}
        translationKey="gift_card_reward"
        translationOptions={{
            amount,
        }}
    />
</RewardsCurrency>
